import { PULSE_ACTION_TYPE } from '@/modules/pulse/utils/pulseConstants';
import { RECOMMENDATION_INTERACTION_TYPE } from './messageParser';

// The Angular `NewMessage` service; see the recommendation README, "Edit".
export const NEW_MESSAGE_MODAL = 'NewMessage';
// The only entry point of that service that puts its text in the editor.
export const NEW_MESSAGE_PREFILL_FUNCTION = 'openWithText';

const REPLY_EDIT_IDENTIFIER_PREFIX = 'bizai-reply-edit:';

export const replyEditIdentifier = (actionUid) => `${REPLY_EDIT_IDENTIFIER_PREFIX}${actionUid}`;

export const isReplyEditIdentifier = (identifier) => String(identifier || '').startsWith(REPLY_EDIT_IDENTIFIER_PREFIX);

/** Only a reply box with the text and the conversation to send it to can be edited. */
export const isEditableReply = (interaction) => !!interaction
  && interaction.type === RECOMMENDATION_INTERACTION_TYPE
  && interaction.action === PULSE_ACTION_TYPE.REPLY
  && !!interaction.suggested_reply
  && !!interaction.client_uid
  && !!interaction.matter_uid;

/**
 * The client row the New Message modal reads (`new-message-service.js.coffee` `parseClients`),
 * built from `/v2/clients/:uid`. The modal only checks the phone for truthiness, to offer SMS.
 */
export const buildNewMessageClient = (client, matterUid) => ({
  uid: client.uid,
  matter_uid: matterUid,
  matter_name: client.full_name,
  full_name: client.full_name,
  first_name: client.first_name,
  last_name: client.last_name,
  email: client.email,
  phone_to_display: client.phone_to_display,
  phone_to_call: client.phone_to_call,
  notifications_phone_normalized_value: client.phone_to_call || null,
  photo_path: client.photo_path,
  color_id: client.color_id,
});

const BLOCK_END = /<\/(p|div|li|h[1-6])>|<br\s*\/?>/gi;

/** The composer sends HTML on rich channels (email); the box shows what was sent as plain text. */
export const htmlToPlainText = (html) => {
  const withBreaks = String(html || '').replace(BLOCK_END, (tag) => `${tag}\n`);
  const text = new DOMParser().parseFromString(withBreaks, 'text/html').body.textContent || '';
  return text.replace(/\n{3,}/g, '\n\n').trim();
};
